module.exports = __webpack_public_path__ + "static/img/6.9cda93f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/6.png
// module id = 6l9W
// module chunks = 0